export default function Style(){
  return (
    <style>
      {`
        @media screen and (max-width: 768px) {
  .responsive-fs {
    font-size: 32px !important;
    line-height: 36px !important;
  }
}


@media screen and (max-width: 992px) {
    .responsive-fs{
        font-size: 38px !important;
        line-height: 43px !important;
    }
}



@media screen and(min-width: 1280px) {
  .responsive-fs {
    font-size: 44px !important;
    line-height: 50px !important;
  }

   
}


@media  screen and(max-width: 1280px) {
  .responsive-fs {
    font-size: 38px !important;
    line-height: 43px !important;
  }
  .fs-16-18{
    font-size: 16px !important;
  }
  .btn-res{
    padding: 14px 24px !important;
  }
}

@media  screen and(min-width: 1534px) {
       .responsive-fs {
         font-size: 48px !important;
         line-height: 54px !important;
       }
        .fs-16-18 {
          font-size: 18px !important;
        }
}
       
        `}
    </style>
  );
}
